import React from 'react';

import {
    Box,
    AppBar,
    Toolbar,
    Typography,
    Container
} from '@material-ui/core';

import useStyles from './styles';

const Dashboard = () => {
    const classes = useStyles();

    return (
        <Box display="flex" m={3} alignItems="center" justifyContent="center">
            <Typography variant="h6" noWrap>
                Dashboard
            </Typography>
        </Box>
    );
};

export default Dashboard;

